// src/components/layout/Footer.js

import React from 'react';
import { useI18n } from '../../i18n/i18nService';

function Footer() {
  const { t } = useI18n();

  return (
    <footer className="bg-gray-800 dark:bg-gray-950 text-white p-4 text-center text-sm rounded-t-lg shadow-inner">
      <p>&copy; {new Date().getFullYear()} IDARAF. {t('all_rights_reserved')}</p>
      <p className="mt-1">{t('developed_with_love')}</p>
    </footer>
  );
}

export default Footer;
